import DocPageLayout from './DocPageLayout.js';
import {
    WarningAmberOutlined,
    HealthAndSafetyOutlined,
    EmojiObjectsOutlined
} from '@mui/icons-material';
import './DocPage.css';

const heroImage = '/img/hero-treatment.jpg';

const symptomSections = [
    {
        icon: WarningAmberOutlined,
        title: '腰痛は、なぜ起こるの？',
        description: [
            '腰痛に苦しむ人の殆どが、その原因についてわかっていません。病院に行っても湿布と痛み止めを出してもらって終わり。根本的な痛みの除去は出来ていないのです。原因が不明だとしても、症状として実際に痛みが発生しているわけです。',
            'では、その体の内部では何が起こっているのでしょうか？'
        ]
    },
    {
        icon: HealthAndSafetyOutlined,
        title: '腰痛の殆どが筋肉の緊張',
        description: [
            '病気や外傷などを除いて起こる腰痛の殆どの痛みは『筋肉の緊張』です。つまり「腰痛＝腰の筋肉の緊張状態」というわけです。筋肉が緊張をすると、様々な不具合を引き起こします。ひとつが血管が圧迫されて血行不良を起こします。血管は酸素を始め、様々な栄養を体中に運びます。その栄養が硬くなった腰の部分には行き渡りにくなるのです。血行不良から、栄養不良状態を引き起こし、更に運動障害に繋がってしまいます。',
            'もう一つは、神経を圧迫する事で、神経伝達機能が低下します。何もしていないのに腰が硬直することで、神経を圧迫させ、腰の神経が脳に痛みを正しく伝達しなくなっているのです。椎間板ヘルニアで苦しんでいる人が、手術をした後にも関わらず、痛みが引かない事があるのはこの為です。'
        ]
    },
    {
        icon: EmojiObjectsOutlined,
        title: '腰痛の施術の方法とは？',
        steps: [
            '腰痛の原因となっている筋肉が硬くなっている箇所（筋肉、筋膜）を徹底的な検査と問診によって究明致します。',
            '次に硬くなった筋肉、筋膜に対して当院独自の全身の筋肉、筋膜、骨盤のバランスを整えます。',
            '再発防止のため体の使い方を見ていきます。'
        ]
    },
    {
        icon: WarningAmberOutlined,
        title: 'このまま腰痛を放っておくと',
        description: [
            '脊柱管狭窄症という腰の付近にある神経の通り道がふさがれ病気になったり',
            '腰の痛みがなかなか取り切れなくなってしまったり',
            '長時間、歩行をすると痛みがひどく出てしまったり',
            '「最悪の場合、歩けなくなる」こともございます',
            '軽い腰痛だから・・・',
            '放っていたら腰痛は治るだろう・・・とかは、大きな間違いです。'
        ]
    }
];

const SymptomLowBackPain = () => (
    <DocPageLayout
        currentRoute="/symptoms/low-back-pain"
        pageTitle="腰痛"
        heroImage={heroImage}
        heroImageAlt="腰痛で悩む方"
        heroHighlight="腰痛は、なぜ起こるの？"
        heroDescription={[
            '腰痛に苦しむ人の殆どが、その原因についてわかっていません。病院に行っても湿布と痛み止めを出してもらって終わり。根本的な痛みの除去は出来ていないのです。原因が不明だとしても、症状として実際に痛みが発生しているわけです。',
            'では、その体の内部では何が起こっているのでしょうか？'
        ]}
    >
        {symptomSections.map(({ icon: Icon, title, description, steps }) => (
            <article key={title} className="doc-section">
                <h3 className="doc-section__title">
                    <Icon className="doc-section__icon" />
                    {title}
                </h3>
                <div className="doc-section__body">
                    {description && description.map((text) => <p key={text}>{text}</p>)}
                    {steps && (
                        <ol className="doc-ordered-list">
                            {steps.map((step) => (
                                <li key={step}>{step}</li>
                            ))}
                        </ol>
                    )}
                </div>
            </article>
        ))}
        <p className="doc-final-note">当院の、腰痛施術を受けて頂くことをお勧めします。</p>
        <div className="doc-page__cta">
            <a
                className="doc-reservation-button"
                href="https://book.squareup.com/appointments/hqjlguwjlxeenh/location/MH09XMWCMM5H9/services"
                target="_blank"
                rel="noopener noreferrer"
            >
                ご予約はこちら
            </a>
        </div>
    </DocPageLayout>
);

export default SymptomLowBackPain;
